import { MapTo } from '@adobe/aem-react-editable-components';
import SingleVideo, { SingleVideoEditConfig } from './SingleVideo';

export default MapTo('cob-corp-acquisition/components/creditonebank/single-video')(SingleVideo, SingleVideoEditConfig);